/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type VehiclesOperationalStateQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
}>

export type VehiclesOperationalStateQuery = {
  __typename?: 'Query'
  vehiclesByIDs: Array<{
    __typename?: 'Vehicle'
    id: string
    operationalState: Types.VehicleOperationalState | null
  }>
}

export const VehiclesOperationalStateDocument = gql`
    query VehiclesOperationalState($ids: [ID!]!) {
  vehiclesByIDs(ids: $ids) {
    id
    operationalState
  }
}
    `

/**
 * __useVehiclesOperationalStateQuery__
 *
 * To run a query within a React component, call `useVehiclesOperationalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehiclesOperationalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehiclesOperationalStateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVehiclesOperationalStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    VehiclesOperationalStateQuery,
    VehiclesOperationalStateQueryVariables
  > &
    (
      | { variables: VehiclesOperationalStateQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VehiclesOperationalStateQuery,
    VehiclesOperationalStateQueryVariables
  >(VehiclesOperationalStateDocument, options)
}
export function useVehiclesOperationalStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehiclesOperationalStateQuery,
    VehiclesOperationalStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VehiclesOperationalStateQuery,
    VehiclesOperationalStateQueryVariables
  >(VehiclesOperationalStateDocument, options)
}
// @ts-ignore
export function useVehiclesOperationalStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VehiclesOperationalStateQuery,
    VehiclesOperationalStateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VehiclesOperationalStateQuery,
  VehiclesOperationalStateQueryVariables
>
export function useVehiclesOperationalStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehiclesOperationalStateQuery,
        VehiclesOperationalStateQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VehiclesOperationalStateQuery | undefined,
  VehiclesOperationalStateQueryVariables
>
export function useVehiclesOperationalStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehiclesOperationalStateQuery,
        VehiclesOperationalStateQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    VehiclesOperationalStateQuery,
    VehiclesOperationalStateQueryVariables
  >(VehiclesOperationalStateDocument, options)
}
export type VehiclesOperationalStateQueryHookResult = ReturnType<
  typeof useVehiclesOperationalStateQuery
>
export type VehiclesOperationalStateLazyQueryHookResult = ReturnType<
  typeof useVehiclesOperationalStateLazyQuery
>
export type VehiclesOperationalStateSuspenseQueryHookResult = ReturnType<
  typeof useVehiclesOperationalStateSuspenseQuery
>
export type VehiclesOperationalStateQueryResult = Apollo.QueryResult<
  VehiclesOperationalStateQuery,
  VehiclesOperationalStateQueryVariables
>
